const fallbackLogger = {
  type: "postProcessor",
  name: "fallbackLogger",
  process: (value, key, options) => {
    if (options?.i18nResolved?.usedNS === "localBundleFallback") {
      console.error(
        `CDN missing translation for key requiring fall back to local bundle. Key: "${key}"`,
        // new Error without throwing to create a stack trace in datadog without otherwise failing
        new Error("CDN missing translation key")
      );
    }
    return value;
  },
};

export default fallbackLogger;
